define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MNaturalEventDomain = void 0;
    class MNaturalEventDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MNaturalEventDomain.FireActive, value: "Fire - active" },
                    { key: MNaturalEventDomain.FireRecent, value: "Fire - recent" },
                    { key: MNaturalEventDomain.FloodActive, value: "Flood - active" },
                    { key: MNaturalEventDomain.FloodRecent, value: "Flood - recent" },
                    { key: MNaturalEventDomain.Drought, value: "Drought" },
                    { key: MNaturalEventDomain.Locust, value: "Locust" },
                    { key: MNaturalEventDomain.Macropod, value: "Macropod" },
                    { key: MNaturalEventDomain.Other, value: "Other" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MNaturalEventDomain.FireActive] = 0;
                this.KeyIndex[MNaturalEventDomain.FireRecent] = 1;
                this.KeyIndex[MNaturalEventDomain.FloodActive] = 2;
                this.KeyIndex[MNaturalEventDomain.FloodRecent] = 3;
                this.KeyIndex[MNaturalEventDomain.Drought] = 4;
                this.KeyIndex[MNaturalEventDomain.Locust] = 5;
                this.KeyIndex[MNaturalEventDomain.Macropod] = 6;
                this.KeyIndex[MNaturalEventDomain.Other] = 7;
                this.ValueIndex = {};
                this.ValueIndex["Fire - active"] = 0;
                this.ValueIndex["Fire - recent"] = 1;
                this.ValueIndex["Flood - active"] = 2;
                this.ValueIndex["Flood - recent"] = 3;
                this.ValueIndex["Drought"] = 4;
                this.ValueIndex["Locust"] = 5;
                this.ValueIndex["Macropod"] = 6;
                this.ValueIndex["Other"] = 7;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MNaturalEventDomain = MNaturalEventDomain;
    Object.defineProperty(MNaturalEventDomain, "FireActive", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(MNaturalEventDomain, "FireRecent", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MNaturalEventDomain, "FloodActive", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MNaturalEventDomain, "FloodRecent", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MNaturalEventDomain, "Drought", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MNaturalEventDomain, "Locust", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MNaturalEventDomain, "Macropod", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MNaturalEventDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 99
    });
    Object.defineProperty(MNaturalEventDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
